import React, { FC } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Screens } from 'core/CssVariables';
import { ButtonDropdown as UIKitButtonDropdown } from '@landlord-tech/ui-kit-opp/dist/components/ButtonDropdown';
import TButtonDropdownProps from './ButtonDropdown.types';

const ButtonDropdown: FC<TButtonDropdownProps> = props => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${Screens.ScreensMD})`,
  });

  return <UIKitButtonDropdown isMobile={isMobile} {...props} />;
};

export default ButtonDropdown;
